import { Box } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  React
};